<nav class="new-navbar" [class.scrolled]="scrolled()" [class.sidebar-collapsed]="isSidebarCollapsed">
  <div class="navbar-container">
    <!-- Left Section -->
    <div class="navbar-left">
      <!-- Sidebar Toggle Button -->
      <button
        class="sidebar-toggle"
        [class.collapsed]="isSidebarCollapsed"
        (click)="onToggleSidebar()"
        type="button"
        [attr.aria-label]="isSidebarCollapsed ? 'Expand sidebar' : 'Collapse sidebar'"
      >
        <!-- Panel layout icon (sidebar open state) -->
        <svg
          class="toggle-icon icon-expanded"
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="1.75"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <rect x="3" y="3" width="18" height="18" rx="3"></rect>
          <line x1="9" y1="3" x2="9" y2="21"></line>
        </svg>
        <!-- Panel with arrow icon (sidebar closed state) -->
        <svg
          class="toggle-icon icon-collapsed"
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="1.75"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <rect x="3" y="3" width="18" height="18" rx="3"></rect>
          <line x1="9" y1="3" x2="9" y2="21"></line>
          <polyline points="14 9 17 12 14 15"></polyline>
        </svg>
      </button>

    </div>

    <!-- Center Section -->
    <!-- <div class="navbar-center">
      <div class="search-container">
        <svg
          class="search-icon"
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
        >
          <circle cx="11" cy="11" r="8"></circle>
          <path d="m21 21-4.35-4.35"></path>
        </svg>
        <input
          type="text"
          class="search-input"
          placeholder="Search anything here..."
          [(ngModel)]="searchText"
          (keyup)="onSearch(searchText)"
        />
        @if (menuItems && menuItems.length > 0) {
          <div class="search-dropdown">
            @for (menuItem of menuItems | slice: 0 : 5; track $index) {
              <a class="search-item" [routerLink]="menuItem?.path" (click)="clearSearch()">
                <i class="fa fa-angle-double-right"></i>
                <span>{{ menuItem?.title }}</span>
              </a>
            }
          </div>
        }
      </div>
    </div> -->

    <!-- Right Section - Toolbar Style -->
    <div class="navbar-right">
      <!-- Organization/Location Selector -->
      @if (dropdownConfig) {
        <div class="toolbar-group org-selector-group">
          <app-select [config]="dropdownConfig.config" (valueChange)="onDropdownChange($event)">
          </app-select>
        </div>
      }

      <!-- Action Icons Group -->
      <div class="toolbar-group actions-group">
        <!-- Xero Integration Status (Admin Only) -->
        @if (isAdmin) {
          @if (xeroStatus$ | async; as status) {
            @if (status.isConnected) {
              <button type="button" class="toolbar-btn xero-connected" aria-label="Xero Connected">
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                >
                  <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                  <polyline points="22 4 12 14.01 9 11.01"></polyline>
                </svg>
                <span class="toolbar-btn-label">Xero</span>
              </button>
            } @else {
              <button
                type="button"
                class="toolbar-btn xero-connect"
                (click)="connectToXero()"
                [disabled]="xeroConnecting"
                aria-label="Connect Xero"
              >
                @if (xeroConnecting) {
                  <span class="spinner-border spinner-border-sm">
                    <span class="visually-hidden">Connecting...</span>
                  </span>
                } @else {
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                  >
                    <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
                    <polyline points="15 3 21 3 21 9" />
                    <line x1="10" y1="14" x2="21" y2="3" />
                  </svg>
                }
                <span class="toolbar-btn-label">Xero</span>
              </button>
            }
          }

          <span class="toolbar-divider"></span>
        }

        <!-- Notifications -->
        <div
          class="notifications-wrapper"
          ngbDropdown
          [autoClose]="'outside'"
          placement="bottom-end"
        >
          <button
            class="toolbar-btn notification-btn"
            type="button"
            aria-label="Notifications"
            ngbDropdownToggle
            id="notificationDropdown"
          >
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
            <span class="notification-dot"></span>
          </button>

          <div
            ngbDropdownMenu
            class="dropdown-menu dropdown-menu-end notification-dropdown"
            aria-labelledby="notificationDropdown"
          >
            <app-template-notification-list
              [isNotificationView]="true"
            ></app-template-notification-list>

            @if (!isNotifyEmpty) {
              <div class="notification-footer">
                <button
                  (click)="onViewAllNotifications()"
                  class="btn btn-primary btn-sm w-100"
                  type="button"
                >
                  View All
                </button>
              </div>
            }

            @if (isNotifyEmpty) {
              <div class="empty-notifications">
                <div class="text-center p-4">
                  <svg
                    class="empty-icon"
                    width="48"
                    height="48"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                  >
                    <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
                    <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
                    <line x1="1" y1="1" x2="23" y2="23"></line>
                  </svg>
                  <h6 class="fw-medium mt-3">No New Notifications</h6>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</nav>
